import { queryOptions, useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { PromotionCode } from '@teetsh/app/src/types/user';

function fetchCustomerPromotionCodes(): Promise<PromotionCode[]> {
  return request('/billing/promotion-codes', { method: 'GET' }).then(
    res => res.data,
  );
}

const promotionCodesQuery = queryOptions({
  queryKey: ['promotionCodes'],
  queryFn: fetchCustomerPromotionCodes,
  refetchOnWindowFocus: false,
});

export function useCustomerActivePromotionCodes() {
  return useQuery(promotionCodesQuery);
}
